import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import { User } from "#root/core/user/user.types";
import { map, Observable, ReplaySubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserStorageService {
  private readonly _user: ReplaySubject<User> = new ReplaySubject<User>(1);
  private readonly _httpClient = inject(HttpClient);

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for user
   *
   * @param value
   */
  set user(value: User) {
    // Store the value
    this._user.next(value);
  }

  get user$(): User {
    const user: User = {
      id: localStorage.getItem("idUser"),
      name: localStorage.getItem("fullName"),
      email: localStorage.getItem("email"),
      avatar: localStorage.getItem("avatar"),
      rol: localStorage.getItem("rol"),
      permissions: JSON.parse(localStorage.getItem("permissions")),
      userPermissionMap: JSON.parse(localStorage.getItem("userPermissionMap")),
      status: "Logueado",
    };
    return user;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get the current logged in user data
   */
  get(): User {
    return this.user$;
  }

  /**
   * Update the user
   *
   * @param user
   */
  update(user: User): Observable<void> {
    return this._httpClient.patch<User>("api/common/user", { user }).pipe(
      map((response) => {
        this._user.next(response);
      }),
    );
  }
}
